import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import NotFound from "./NotFound";
import BrandText from "../components/BrandText";

const PAGES = {
  faq: { title: "For International Buyers", sections: [
    ["Who is this showroom for?", "International importers, wholesalers and retail brands sourcing home décor in bulk. Share your company and destination country when enquiring."],
    ["How do I request a quotation?", "Add products to your enquiry basket and share your indicative quantities and requirements. Our team will discuss specifications and a quotation with you by email."],
    ["What is the minimum quantity?", "Our minimum order quantity is 500 pieces. Share your proposed product mix so our team can confirm design-wise quantities and a quotation."],
    ["Can I request a catalogue?", "Use Request Catalogue and tell us about your business, market and product interests. Our team can discuss the relevant collection with you."],
    ["Can we discuss materials and finishes?", "Yes. Include your preferred materials, finishes, dimensions and sample requirements in your enquiry so our team can review your brief."]
  ]},
  terms: { title: "Trade Enquiries", sections: [
    ["A showroom for bulk sourcing", "S H & SONS ® is a manufacturer and exporter based in Moradabad, India. This website accepts enquiries from businesses outside India."],
    ["From shortlist to quotation", "Submitting an enquiry does not place an order or take payment. Product specifications, quantities, lead times, delivery and commercial terms are agreed directly with our team."],
    ["Product information", "Images and descriptions help you build a shortlist. Confirm final materials, dimensions, finishes and sample requirements with our team before proceeding."],
    ["International export payment terms", "30% advance and 70% against Bill of Lading (B/L). Submitting an enquiry does not constitute order acceptance or payment confirmation."],
    ["Contact", "Email hello@shandsons.in or call +91 9870651826."]
  ]},
  privacy: { title: "Enquiry Privacy", sections: [
    ["Information you share", "The enquiry form asks for your name, business email, company, country, mobile number and product requirements. Indicative quantities are optional."],
    ["Responding to your enquiry", "We use these details to review and respond to your sourcing enquiry. Your product shortlist is stored in your browser until you remove it or submit it."],
    ["Your information", "For questions about your enquiry or to request a correction or deletion, contact hello@shandsons.in."]
  ]}
};

export default function StaticPage() {
  const { page } = useParams();
  const [remote, setRemote] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { let active=true; setLoading(true); setRemote(null); api.site("content").then(data=>{if(active)setRemote((data.pages||[]).find(item=>item.slug===page && item.enabled!==false)||null)}).catch(()=>{}).finally(()=>{if(active)setLoading(false)}); return ()=>{active=false}; }, [page]);
  const content = remote || PAGES[page];
  if (loading) return <p role="status" className="p-12 text-center">Loading page…</p>;
  if (!content) return <NotFound />;

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-8 pt-8 sm:pt-12 pb-28" data-testid={`page-${page}`}>
      <SEO title={`${content.title} — S H & SONS ®`} description={content.intro || content.sections[0]?.body || content.sections[0]?.[1]} />
      <Reveal className="text-center">
        <p className="eyebrow mb-4"><span className="brand-name">S H &amp; SONS ®</span></p>
        <h1 className="h-display text-4xl sm:text-5xl lg:text-[64px] text-balance"><BrandText text={content.title} /></h1>
      </Reveal>
      {content.intro && <p className="mt-6 text-base sm:text-lg text-mocha text-center leading-relaxed">{content.intro}</p>}
      <div className="mt-12 space-y-0">
        {content.sections.map((section, i) => {
          const [h, t] = Array.isArray(section) ? section : [section.heading, section.body];
          return (
          <Reveal key={h} delay={i * 0.05}>
            <div className="py-7 border-b border-line">
              {section.image&&<img src={section.image} alt={section.image_alt||section.heading||""} className="w-full rounded-2xl mb-6" loading="lazy"/>}
              <h2 className="text-[19px] sm:text-[22px] font-light"><BrandText text={h} /></h2>
              <p className="mt-2.5 text-base text-charcoal/80 leading-relaxed"><BrandText text={t} /></p>
            </div>
          </Reveal>
          );
        })}
      </div>
      <nav aria-label="Buyer resources" className="mt-10 flex flex-wrap gap-4 text-sm"><Link to="/pages/factory-capabilities" className="underline underline-offset-4">Factory & Capabilities</Link><Link to="/pages/moq-oem" className="underline underline-offset-4">MOQ & OEM</Link><Link to="/pages/faq" className="underline underline-offset-4">Buyer FAQs</Link></nav>
      <Link to="/contact" className="pill-dark mt-8">Discuss your collection</Link>
    </div>
  );
}
